import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../AccountsWorkflowConstants';
import { inputCheckboxClicked } from '../../../Profile/Accounts_react/AccountsUtils';
import YesOrNoCheckbox from '../../YesOrNoCheckbox/YesOrNoCheckboxView';
import { validateHasYourFamilyStartedSaving } from '../AccountsWorkflowValidators';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';

export default class HasYourFamilyStartedSavingView extends Component {
  componentDidUpdate({ isPopulated: previousIsPopulated }) {
    const {
      clientId, workflowId, preprocessData, store2, accounts, isPopulated,
    } = this.props;

    if (!previousIsPopulated && isPopulated) {
      preprocessData(clientId, accounts, store2(workflowId));
    }
  }

  render() {
    const {
      branch,
      workflowId,
      clientId,
      hasYourFamilyStartedSaving,
      store2,
      title,
      alreadyHasYourFamilyStartedSavingData,
    } = this.props;

    return (
      <AdvWorkflowStep
        branch={branch}
        workflowId={workflowId}
        canSkip={alreadyHasYourFamilyStartedSavingData}
      >
        <Validation
          workflowId={workflowId}
          validationId={`${BACKEND_KEY}.HasYourFamilyStartedSaving`}
        />
        <h2>{title}</h2>
        <YesOrNoCheckbox
          checked={hasYourFamilyStartedSaving}
          onClick={inputCheckboxClicked(
            clientId,
            store2(workflowId),
            `${BACKEND_KEY}.HasYourFamilyStartedSaving`,
          )}
        />

        <Navigation
          nextIterators={[]}
          dirtyGraphNodes={[]}
          validator={validateHasYourFamilyStartedSaving(hasYourFamilyStartedSaving)}
          validationId={`${BACKEND_KEY}.HasYourFamilyStartedSaving`}
          workflowId={workflowId}
          backendKey={BACKEND_KEY}
          doNotSave
          validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'savings_completed')}
        />
      </AdvWorkflowStep>
    );
  }
}
HasYourFamilyStartedSavingView.defaultProps = {
  hasYourFamilyStartedSaving: null,
};

HasYourFamilyStartedSavingView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string.isRequired,
  hasYourFamilyStartedSaving: PropTypes.bool,
  alreadyHasYourFamilyStartedSavingData: PropTypes.bool.isRequired,
  preprocessData: PropTypes.func.isRequired,
  accounts: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  isPopulated: PropTypes.bool.isRequired,
  store2: PropTypes.func.isRequired,
};
